import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { canUseDOM } from 'exenv';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { SCROLLABLE_ELEMENT_CLASSNAME as NAV_SCROLLABLE_ELEMENT_CLASSNAME } from '@nerdwallet/global-nav-vars';
import { breakpoints } from '@nerdwallet/base-styles/variables'; // Lib

import { formCancel, formMoveToPage, formSubmit } from '@nerdwallet/nw-client-lib/tracking';
import { Button, Link } from '@nerdwallet/currency';
import Box from '@nerdwallet/react-box'; // Styles

import styles from './screen-container.module.less'; // Internal components

import NavbarHeader from './navbar-header';

var isIos = function isIos() {
  var _window, _window$navigator, _window$navigator$use, _window$navigator$use2;

  return (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : (_window$navigator$use = _window$navigator.userAgent) === null || _window$navigator$use === void 0 ? void 0 : (_window$navigator$use2 = _window$navigator$use.toLowerCase()) === null || _window$navigator$use2 === void 0 ? void 0 : _window$navigator$use2.includes('iphone');
};

var ScreenContainer = /*#__PURE__*/function (_Component) {
  _inherits(ScreenContainer, _Component);

  var _super = _createSuper(ScreenContainer);

  function ScreenContainer(props) {
    var _this;

    _classCallCheck(this, ScreenContainer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "enableScrollLocks", function () {
      if (!canUseDOM) {
        return;
      } // check whether or not we're on desktop or mobile
      // only in mobile do we want to disable/enable body scroll


      var mq = window.matchMedia(breakpoints.wide);

      if (mq.matches) {
        return;
      }

      var enableScrollLocks = _this.props.enableScrollLocks;

      if (enableScrollLocks) {
        // we are on mobile so disable scroll
        // disable body scroll except on the container we want to keep scrollable
        disableBodyScroll(_this.scrollableContainer.current);

        if (isIos()) {
          document.querySelectorAll(".".concat(NAV_SCROLLABLE_ELEMENT_CLASSNAME)).forEach(function (node) {
            disableBodyScroll(node);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "disableScrollLocks", function () {
      // clear body scroll lock set in CDM
      clearAllBodyScrollLocks();
    });

    _defineProperty(_assertThisInitialized(_this), "onScroll", function (e) {
      if (!e.target || e.target !== _this.scrollableContainer.current) {
        return;
      } // if scroll and client height are equal, there is not more room to scroll
      // so we are at the bottom of the container


      var isBottom = Math.round(e.target.scrollHeight - e.target.scrollTop) <= e.target.clientHeight;

      _this.setState({
        isContainerBottom: isBottom
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isScrollable", function (element) {
      if (!element) {
        return false;
      } // check if scrollHeight is greater than clientHeight
      // this means there is room to scroll and we are not at the bottom of the container


      return element.scrollHeight > element.clientHeight;
    });

    _this.scrollableContainer = /*#__PURE__*/React.createRef();
    _this.state = {
      isContainerBottom: true
    };
    return _this;
  }

  _createClass(ScreenContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.enableScrollLocks(); // disabling because we need the container to be rendered in order for us to know if its scrollable

      this.setState({
        isContainerBottom: !this.isScrollable(this.scrollableContainer.current)
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var enableScrollLocks = this.props.enableScrollLocks;

      if (prevProps.enableScrollLocks !== enableScrollLocks) {
        // this.props.enableScrollLocks === true means previously it was disable and now we need to re-enable it
        // this.props.enableScrollLocks === false means previously it was enable and now we need to disable it
        if (enableScrollLocks) {
          this.enableScrollLocks();
        } else {
          this.disableScrollLocks();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.disableScrollLocks();
    }
  }, {
    key: "render",
    value: function render() {
      var _classnames, _classnames3;

      var _this$props = this.props,
          disableStickyCta = _this$props.disableStickyCta,
          primaryCta = _this$props.primaryCta,
          children = _this$props.children,
          skipCta = _this$props.skipCta,
          disclaimer = _this$props.disclaimer,
          tracking = _this$props.tracking,
          showBack = _this$props.showBack,
          onBack = _this$props.onBack,
          onCancel = _this$props.onCancel,
          showClose = _this$props.showClose,
          ctaAlign = _this$props.ctaAlign,
          backLabel = _this$props.backLabel,
          hideLogoOnMobile = _this$props.hideLogoOnMobile,
          submitContainerStyle = _this$props.submitContainerStyle,
          nerdyInsight = _this$props.nerdyInsight;
      var buttonText = primaryCta.text,
          isDisabled = primaryCta.isDisabled,
          isLoading = primaryCta.isLoading;
      var isContainerBottom = this.state.isContainerBottom;

      var handleBack = function handleBack() {
        formMoveToPage({
          formName: tracking.formName,
          fieldValue: 'backArrow',
          fieldName: tracking.fieldName
        });
        onBack();
      };

      var ctaAlignment = classnames((_classnames = {}, _defineProperty(_classnames, styles.ctaAlignLeft, ctaAlign === 'left'), _defineProperty(_classnames, styles.ctaAlignRight, ctaAlign === 'right'), _defineProperty(_classnames, styles.ctaAlignCenter, ctaAlign === 'center'), _classnames));

      var handleClose = function handleClose() {
        if (tracking.waitForFormCancel && window.nwa) {
          window.nwa.track('FORM_INPUT_CHANGED_EVENT', {
            action: 'FORM_CANCEL',
            formName: tracking.formName,
            fieldValue: 'exit',
            fieldName: tracking.fieldName
          }, onCancel);
        } else {
          formCancel({
            formName: tracking.formName,
            fieldValue: 'exit',
            fieldName: tracking.fieldName
          });
          onCancel();
        }
      };

      var handleSubmit = function handleSubmit(e) {
        e.preventDefault();

        if (!isDisabled) {
          var action = primaryCta.isSubmit ? formSubmit : formMoveToPage; // if there is custom tracking for a cta, fire the custom events first
          // then fire formSubmit or formMoveToPage

          primaryCta.onClick();
          action({
            formName: tracking.formName,
            fieldValue: primaryCta.text,
            fieldName: tracking.fieldName
          });
        }
      };

      var handleSkip = function handleSkip() {
        formSubmit({
          formName: tracking.formName,
          fieldValue: skipCta.text,
          fieldName: tracking.fieldName
        });
        skipCta.onClick();
      };

      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: classnames(styles.form)
      }, /*#__PURE__*/React.createElement("div", {
        className: classnames(styles.container, _defineProperty({}, styles.sticky, !disableStickyCta)),
        ref: this.scrollableContainer,
        onScroll: this.onScroll
      }, (showBack || !hideLogoOnMobile || showClose) && /*#__PURE__*/React.createElement(NavbarHeader, {
        showBack: showBack,
        showClose: showClose,
        tracking: tracking,
        hideLogoOnMobile: hideLogoOnMobile,
        onBack: handleBack,
        backLabel: backLabel,
        onCancel: handleClose
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.inputs
      }, children)), primaryCta.text && /*#__PURE__*/React.createElement("div", {
        className: classnames(styles.submitContainer, submitContainerStyle, (_classnames3 = {}, _defineProperty(_classnames3, styles.boxShadow, !(isContainerBottom || disableStickyCta)), _defineProperty(_classnames3, styles.hasInsight, nerdyInsight), _classnames3))
      }, nerdyInsight && /*#__PURE__*/React.createElement(Box, {
        className: styles.insightContainer,
        wide: {
          columns: 8,
          noGutter: 'both'
        },
        small: {
          columns: 12,
          noGutter: 'both'
        }
      }, nerdyInsight), /*#__PURE__*/React.createElement(Box, {
        className: ctaAlignment
      }, primaryCta.text && /*#__PURE__*/React.createElement(Box, {
        wide: {
          columns: 3,
          noGutter: 'both'
        },
        small: {
          columns: 4,
          noGutter: 'both'
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        className: styles.submitButton,
        primary: true,
        disabled: isDisabled,
        loading: isLoading,
        onClick: handleSubmit
      }, buttonText)), skipCta.text && /*#__PURE__*/React.createElement(Link, {
        className: styles.skipText,
        onClick: handleSkip,
        size: 1,
        gotham: true
      }, skipCta.text)), disclaimer && /*#__PURE__*/React.createElement("div", {
        className: classnames(styles.disclaimer, ctaAlignment)
      }, disclaimer)));
    }
  }]);

  return ScreenContainer;
}(Component); // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration


ScreenContainer.displayName = 'ScreenContainer'; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ScreenContainer.propTypes = {
  /** whether or not to allow scroll locking in the container */
  enableScrollLocks: PropTypes.bool,

  /** whether or not to allow cta to be sticky */
  disableStickyCta: PropTypes.bool,

  /** whether or not to show back button */
  showBack: PropTypes.bool,

  /** whether or not to show close button */
  showClose: PropTypes.bool,

  /** action when back arrow is clicked */
  onBack: PropTypes.func,

  /** label text for back button */
  backLabel: PropTypes.string,

  /** action when 'x' in top right corner is clicked */
  onCancel: PropTypes.func,

  /** alignment for cta */
  ctaAlign: PropTypes.oneOf(['left', 'right', 'center']),

  /** properties of the submit button, or primary cta */
  primaryCta: PropTypes.shape({
    onClick: PropTypes.func,
    text: PropTypes.string,
    isSubmit: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isLoading: PropTypes.bool
  }),

  /** optional behavior to skip this question with link that will be next to submit button */
  skipCta: PropTypes.shape({
    onClick: PropTypes.func,
    text: PropTypes.string
  }),
  tracking: PropTypes.shape({
    /** the name of the form this field is being used in, will be sent as a tracking parameter */
    formName: PropTypes.string.isRequired,

    /** the name of this field, will be sent as a tracking parameter */
    fieldName: PropTypes.string.isRequired,

    /** whether or not to wait for formCancel to complete before calling onCancel in handleClose  */
    waitForFormCancel: PropTypes.bool
  }).isRequired,

  /** children that will be placed between nav buttons and submit button */
  children: PropTypes.node,

  /** optional disclaimer text that goes below submit button */
  disclaimer: PropTypes.node,

  /** optional flag to hide the NW logo on mobile web */
  hideLogoOnMobile: PropTypes.bool,

  /** optional style to be applied to the submit container */
  submitContainerStyle: PropTypes.string,

  /** optional nerdy insight to display to the user */
  nerdyInsight: PropTypes.node
}; // eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration

ScreenContainer.defaultProps = {
  enableScrollLocks: true,
  disableStickyCta: false,
  showBack: true,
  backLabel: '',
  children: null,
  onBack: function onBack() {},
  onCancel: function onCancel() {},
  showClose: true,
  ctaAlign: 'left',
  skipCta: {
    onClick: function onClick() {},
    text: null
  },
  disclaimer: null,
  primaryCta: {
    isSubmit: false,
    isDisabled: false,
    isLoading: false,
    onClick: function onClick() {},
    text: ''
  },
  hideLogoOnMobile: false,
  submitContainerStyle: null,
  nerdyInsight: null
};
export default ScreenContainer;